export default __webpack_public_path__ + "static/media/block-four-4.ba410bd4.png";